// extracted by mini-css-extract-plugin
module.exports = {"AcademyFilter":"AcademyFilters_AcademyFilter__rKUZO","AcademyFilter_filtersContainer":"AcademyFilters_AcademyFilter_filtersContainer__dlVGf"};